<template>
  <div class="page-container">
    <!-- Export module -->
    <div class="module-content">
      <!-- Header -->
      <div class="module-header">
        <div class="left">
          <h1>Exports Data</h1>
        </div>
        <div v-if="!isLoadingDonations && !isDownloading && !isMarkingExports" class="right">
          <!-- Date Picker -->
          <DatePicker :dateRange="settings.dateRange" @dateSelected="dateSelected"></DatePicker>

          <!-- Settings -->
          <!-- <ExportsDataSetting @confirmed="fetchDonations" /> -->
        </div>
      </div>

      <div v-if="!isLoadingDonations && !isDownloading && !isMarkingExports" class="container">
        <!-- Donation Table -->
        <div class="table-wrapper" style="height: 90%; margin-bottom: 10px">
          <Table :items="donations['All']" :attributes="tableAttributes" :options="tableOptions"></Table>
          <!-- @edit="viewDonation" -->
        </div>

        <!-- Download btn -->
        <button @click="downloadFiles()">
          Download
          <i class="icn icn-document-download"></i>
        </button>

        <!-- Mark as exported btn -->
        <button @click="markAsExported()" style="margin-left: 30px">
          Mark donations as exported
          <i class="icn icn-check-circle"></i>
        </button>
      </div>

      <!-- Downloading screen -->
      <div v-if="isDownloading" class="container w-max">
        <div class="flex flex-col items-center">
          <img class="h-36 mt-20" src="@/assets/img/loading.svg" />
          <h2>Downloading files</h2>
        </div>
      </div>

      <!-- Loading screen -->
      <div v-if="isLoadingDonations" class="container w-max">
        <div class="flex flex-col items-center">
          <img class="h-36 mt-20" src="@/assets/img/loading.svg" />
          <h2>Fetching donations</h2>
        </div>
      </div>

      <!-- isMarkingExports screen-->
      <div v-if="isMarkingExports" class="container w-max">
        <div class="flex flex-col items-center">
          <img class="h-36 mt-20" src="@/assets/img/loading.svg" />
          <h2>Marking donations as exported</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ExportsDataSetting from './ExportsDataSetting.vue';
import { format, isSameDay } from 'date-fns';
import { MESSAGES } from '@/helpers/constants';
import { mapState } from 'vuex';
import Table from '@/components/Table.vue';
// import { PERMISSION, MODULE } from '@/helpers/security';
import DatePicker from '@/components/DatePicker.vue';
import { parseAsync } from 'json2csv';
import JSZip from 'jszip';

export default {
  name: 'ExportsData',

  components: {
    // ExportsDataSetting,
    Table,
    DatePicker,
  },

  data() {
    return {
      isDownloading: false,
      isLoadingDonations: false,
      isShowingDetails: false,
      isMarkingExports: false,

      donations: {},
      selectedDonation: null,
      tableOptions: {
        edit: false,
        editLabel: 'View',
      },
      tableAttributes: [
        { name: 'GFT_Date', label: 'Date' },
        { name: 'SUP_DTL_FirstName', label: 'First Name' },
        { name: 'SUP_DTL_LastName', label: 'Last Name' },
        { name: 'GFT_Receipted', label: 'Receipt No' },
        { name: 'SUP_DTL_Email', label: 'Email' },
        { name: 'GFT_Amount', label: 'Amount' },
        { name: 'GFT_PayMeth', label: 'Payment Method' },
      ],
    };
  },

  computed: {
    fileName() {
      console.log(this.settings.dateRange);
      return isSameDay(this.settings.dateRange.start, this.settings.dateRange.end)
        ? format(this.settings.dateRange.start, 'd-M-y')
        : `${format(this.settings.dateRange.start, 'd-M-y')}_to_${format(this.settings.dateRange.end, 'd-M-y')}`;
    },
    ...mapState({
      settings: state => state.exportsData.settings,
      csvfieldsOrder: state => state.exportsData.csvfieldsOrder,
      csvfieldsOrderDon: state => state.exportsData.csvfieldsOrderDon,
    }),
  },

  mounted() {
    this.fetchDonations();
  },

  methods: {
    async fetchDonations() {
      this.isLoadingDonations = true;
      // Fetch all donations
      try {
        const { data } = await this.$store.dispatch('exportsData/fetchDonations');
        this.donations = data;
        // Set up all donations view
        this.donations.All = [];
        for (const files of Object.values(data)) {
          this.donations.All = [...this.donations.All, ...files];
        }
      } catch (err) {
        this.$store.dispatch('notifications/error', {
          headline: MESSAGES.ERROR_FETCH,
        });
        console.error(err);
      } finally {
        this.isLoadingDonations = false;
      }
    },
    dateSelected(newRange) {
      this.settings.dateRange = { ...newRange };
      this.fetchDonations();
    },
    async downloadFiles() {
      this.isDownloading = true;
      try {
        // Create zip
        const zip = new JSZip();
        for (const [type, data] of Object.entries(this.donations)) {
          if (type != 'All') {
            const fields = type.includes('DON') ? this.csvfieldsOrderDon : this.csvfieldsOrder;
            // Create csvs
            const csv = await parseAsync(data, { fields });
            const fileName = `${type}_${data.length}.csv`;
            zip.file(fileName, csv);
          }
        }

        // Create blob & link of object
        const blob = await zip.generateAsync({ type: 'blob' });
        const url = URL.createObjectURL(blob);

        // Download csv zip
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.target = '_blank';
        anchor.download = `RE_imports_${this.fileName}.zip`;
        anchor.click();

        // Clean up
        URL.revokeObjectURL(url);
      } catch (err) {
        this.$store.dispatch('notifications/error', {
          headline: MESSAGES.SERVER_ERROR,
        });
        console.error(err);
      } finally {
        this.isDownloading = false;
      }
    },
    async markAsExported() {
      this.isMarkingExports = true;

      // Mark donation as exported
      try {
        await this.$store.dispatch('exportsData/markAsExported');
      } catch (err) {
        this.$store.dispatch('notifications/error', {
          headline: MESSAGES.SERVER_ERROR,
        });
        console.error(err);
      }
      this.isMarkingExports = false;

      // Fetch Donations
      await this.fetchDonations();
      console.log(this.donations);
    },
  },
};
</script>
